<!-- 2 columns form -->
<form #userForm="ngForm" name="userForm">
  <div class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">Add User</h5>
      <div class="heading-elements">
        <ul class="icons-list">
          <li>
            <a data-action="reload" ng-click="mainService.reload()"></a>
          </li>
        </ul>
      </div>
      <hr class="divider">
    </div>

    <div class="panel-body">

      <div class="row">
        <fieldset>
          <legend class="text-semibold">
            <i class="icon-reading position-left"></i> User details
          </legend>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group required"
                [ngClass]="{'has-error':(nameControl.touched && nameControl.invalid) || (nameControl.invalid && formHasError)}">
                <span class="control-label"> Name: </span>
                <input type="text" name="name" required [(ngModel)]="user.username" #nameControl="ngModel"
                  class="form-control" placeholder="user name">
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group required"
                [ngClass]="{'has-error': (emailControl.touched && emailControl.invalid) || (emailControl.invalid && formHasError)}">
                <span class="control-label"> Email Address: </span>
                <input type="text" name="email" required [(ngModel)]="user.email" #emailControl="ngModel"
                  class="form-control" placeholder="user email address">
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group required"
                [ngClass]="{'has-error': (phoneControl.touched && phoneControl.invalid) || (phoneControl.invalid && formHasError)}">
                <span class="control-label"> Phone Number: </span>
                <input type="text" name="phone" [(ngModel)]="user.phone_number" #phoneControl="ngModel"
                  class="form-control" placeholder="user phone number">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group required"
                [ngClass]="{'has-error':(statusControl.touched && statusControl.invalid) || (statusControl.invalid && formHasError)}">
                <span class="control-label">Status: </span>
                <select name="status" required [(ngModel)]="user.status" #statusControl="ngModel" class="form-control"
                  data-placeholder="Status">
                  <option selected disabled>Status:</option>
                  <option value="registered">Registered</option>
                  <option value="pending">Pending</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>

          </div>

          <div class="row">

            <div class="col-md-3">
              <div class="form-group required"
                [ngClass]="{'has-error':(passwordControl.touched && passwordControl.invalid) || (passwordControl.invalid && formHasError) || !match}">
                <span class="control-label"> Password: </span>
                <input type="password" name="password" [(ngModel)]="user.password" #passwordControl="ngModel"
                  class="form-control" placeholder="user password">
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group required"
                [ngClass]="{'has-error':(passwordConfControl.touched && passwordConfControl.invalid) || (passwordConfControl.invalid && formHasError) || !match}">
                <span class="control-label">Confirm Password: </span>
                <input type="password" name="passwordconf" [(ngModel)]="user.password_confirmation"
                  #passwordConfControl="ngModel" class="form-control" placeholder="enter password again">
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group required"
                [ngClass]="{'has-error':(typeControl.touched && typeControl.invalid) || (typeControl.invalid && formHasError)}">
                <span class="control-label">User Type: </span>
                <select name="type" required [(ngModel)]="user.type" #typeControl="ngModel" class="form-control"
                  data-placeholder="Type">
                  <option selected disabled>Type:</option>
                  <option value="system_user">System User</option>
                  <option value="system_admin">System Admin</option>
                  <option value="super_admin">Super Admin</option>
                </select>
              </div>
            </div>

            <div class="col-md-3" *ngIf="user.type =='system_admin' || user.type =='super_admin'">
              <div class="form-group required">
                <span class="control-label">Branch: </span>
                <ng-select [items]="branches" placeholder="" name="branch"  [(ngModel)]="user.branch_id" #typeControl="ngModel"  bindValue="id" bindLabel="text"
                  required>
                </ng-select>
              </div>
            </div>

          </div>

        </fieldset>

      </div>

      <div class="text-right">
        <button class="btn bg-slate-800" (click)="addUser(user.id)" type="submit" data-style="slide-right"
          [ladda]="isLoading" [disabled]="userForm.invalid">
          <span *ngIf="!user.id">Save User</span>
          <span *ngIf="user.id">Update User</span>
          <i class="icon-floppy-disk position-right"></i>
        </button>
      </div>
    </div>
  </div>
</form>
<!-- /2 columns form -->